<template>
  <div>
    <h1>404</h1>
    <p>Page not found</p>
    <router-link to="/dashboard">Go to Home</router-link>
  </div>
</template>

<script setup></script>

<style scoped></style>
